// extracted by mini-css-extract-plugin
export default {"select_island":"CloseIsland_select_island__0OI3E","open":"CloseIsland_open__hobRv","island_title":"CloseIsland_island_title__-c+fo","close":"CloseIsland_close__EufL0"};